module.exports = __webpack_public_path__ + "img/home.ba696957.svg";